import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { RenderCheckboxRadioField } from '../../form';
import './CustomDomainModal.less';

class CustomDomainModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionClicked: 1,
      optionName: 'zola'
    };
    this.selectOption = this.selectOption.bind(this);
  }

  selectOption(optionClicked) {
    this.setState({
      active: !this.state.active,
      optionClicked,
      // optionName: optionClicked === 1 ? 'zola' : 'other'
    });
  }


  render() {
    const { optionClicked } = this.state;
    const { hideModalFn, showModalFn } = this.props;
    const ZolaDomainStore = 'https://domains.zola.com';
    const ConnectYourOwnDomain = 'https://help.zola.com/hc/en-us/articles/115001755071-How-do-I-connect-a-domain-name-I-purchased-somewhere-else-to-my-wedding-website-';
    const LearnMore = 'https://help.zola.com/hc/en-us/articles/115001765672-How-can-I-change-my-wedding-website-address-';

    return (
      <div id="custom-domain-modal" className="modal-dialog modal-md container-fluid">
        <div className="body row">
          <div className="heading">
            <h1 className="modal-heading">Purchase or Connect a Custom Domain</h1>
          </div>
          <div className="option-container">
            <div className="option col-xs-12" onClick={() => { this.selectOption(1); }}>
              <Field
                component={RenderCheckboxRadioField}
                id="domain-radio-one"
                name="domain-name-radio"
                type="radio"
                inline
                styleOverride
                className={[optionClicked === 1 ? 'active' : null, 'col-xs-2 col-sm-1'].join(' ')}
              />
              <div className={['body-copy col-xs-10 col-sm-11', optionClicked === 1 ? 'active' : null].join(' ')} onClick={() => { this.selectOption(1); }}>
                <h2>Purchase a Custom Domain</h2>
                <p>Add an extra personal touch to your wedding website.</p>
                <p className="text-btn hidden-xs"><Link to={LearnMore} target="_blank" rel="noopener noreferrer">Learn more about custom domains ›</Link></p>
                <p className="text-btn hidden visible-xs"><Link to={LearnMore} target="_blank" rel="noopener noreferrer">Learn more ›</Link></p>
              </div>
            </div>
            <div className="option col-xs-12" onClick={() => { this.selectOption(2); }}>
              <Field
                component={RenderCheckboxRadioField}
                id="domain-radio-two"
                type="radio"
                inline
                styleOverride
                name="domain-name-radio"
                className={[optionClicked === 2 ? 'active' : null, 'col-xs-2 col-sm-1'].join(' ')}
              />
              <div className={['body-copy col-xs-10 col-sm-11', optionClicked === 2 ? 'active' : null].join(' ')} onClick={() => { this.selectOption(2); }}>
                <h2>Connect a Domain You Already Own</h2>
                <p>We&apos;ll guide you through this simple process.</p>
              </div>
            </div>
          </div>
          <div className="cancel-or-confirm pull-right">
            <Link className="hidden-xs" onClick={() => hideModalFn()}>
              <div className="btn btn-secondary">Cancel</div>
            </Link>
            <Link to={optionClicked === 1 ? ZolaDomainStore : ConnectYourOwnDomain} target="_blank" rel="noopener noreferrer" onClick={() => { if (optionClicked === 1) { showModalFn('CUSTOM_DOMAIN_COMPLETION_MODAL', {}, { size: 'md' }); } else { hideModalFn(); } }} className="text-button">
              <div className="btn btn-primary">Continue</div>
            </Link>
            <Link className="hidden visible-xs" onClick={() => hideModalFn()}>
              <div className="btn btn-secondary">Cancel</div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

CustomDomainModal.propTypes = {
  hideModalFn: PropTypes.func,
  showModalFn: PropTypes.func
};


export default connect(
  null, null
)(reduxForm({
  form: 'DomainName',
  enableReinitialize: true
})(CustomDomainModal));



// WEBPACK FOOTER //
// ./src/components/common/modals/CustomDomainModal/CustomDomainModal.jsx